<template>
  <footer class="w3-footer">
    <div class="container">
      <div>
        <div class="footer-logo">
          <img :src="setting.setting.image ? setting.setting.image.full_url : ''" v-if="setting.setting.image" alt="{{ setting.setting.company_name }}" class="logo">
          <h3 v-else>{{ setting.setting.company_name }}</h3>
        </div>
        <div class="menu-with-social-media">
          <ul class="footer-menu">
            <li><a href="#" target="_blank">Blog</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
          <ul class="footer-social-media">
            <li><a href="{{ setting.setting.facebook }}" target="_blank">
                <i class="fab fa-square-facebook p-0 text-15px"></i>

              </a></li>
            <li><a href="{{ setting.setting.youtube }}" target="_blank"><i class="fab fa-youtube p-0 text-15px"></i></a></li>
            <li><a href="{{ setting.setting.linkedin }}" target="_blank"><i class="fab fa-linkedin p-0 text-15px"></i></a></li>
            <li><a href="{{ setting.setting.twitter }}" target="_blank"><i class="fab fa-twitter p-0 text-15px"></i></a></li>
          </ul>
        </div>
        <div class="footer-menu-bottom mt-20">
          <a target="_blank" href="#">
            Copy Right By {{ setting.setting.company_name }} {{ new Date().getFullYear() }}
          </a>
          <div>
            <ul class="bottom-footer-menu">
              <li><router-link to="/privacy-policy">Privacy policy</router-link></li>
              <li><router-link to="/terms-and-condition">Terms and condition</router-link></li>
              <li><router-link to="/faq">Faq</router-link></li>
              <li><router-link to="/shipping-delivery">Shipping & Delivery</router-link></li>
              <li><router-link to="/refund-return-policy">Refund & Return policy</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-footer-menu">
      <el-menu default-active="1" class="el-menu-horizontal-demo" mode="horizontal" :ellipsis="false" :router="true">

        <el-menu-item index="/">
          <el-icon>
            <Grid />
          </el-icon>
        </el-menu-item>

        <el-menu-item index="/products">
          <el-icon><Tickets /></el-icon>
        </el-menu-item>
        
        <el-menu-item index="/user/order/list">
          <el-icon>
            <User/>
          </el-icon>
        </el-menu-item>
        <el-menu-item index="/contact">
          <el-icon>
            <Headset />
          </el-icon>
        </el-menu-item>
        <el-menu-item index="/login">
          <el-icon><SwitchButton /></el-icon>
        </el-menu-item>
      </el-menu>
    </div>
  </footer>
</template>

<script>
import { User } from '@element-plus/icons-vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    // ...mapGetters('auth', ['authUser', 'loggedIn']),
    ...mapGetters({
      setting: 'setting/get_setting',
    })
  },

};
</script>

<style scoped>
.w3-footer {
  background-color: #fff;
  border: 1px solid rgba(71, 85, 105, .1);
  padding: 50px 50px;
  margin-top: 50px;
}

.menu-with-social-media {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.footer-menu {
  display: flex;
  /*padding-right: 10px;*/
  font-size: .875rem;
  line-height: 1.25rem;
  color: #0B0718;
}

.menu-with-social-media ul li a {
  padding-right: 20px;
  color: #0B0718;
}

.footer-social-media {
  display: flex;
}

.footer-social-media ul {
  margin: 0;
  padding: 0;
}

.footer-social-media ul li a {
  padding-right: 20px;
  color: #0B0718;
}

.footer-logo {
  /* width: 177px;
  height: 44px; */
  margin-bottom: 30px;
}

.footer-menu-bottom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.bottom-footer-menu {
  display: flex;
  color: #0B0718;
}

.bottom-footer-menu li a {
  padding-right: 20px;
  color: #0B0718;
  font-size: .875rem;
  line-height: 1.25rem;
}
</style>
